(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["future-legacy"] && !Shopify.designMode) return;
  try {
    
function initFutureLegacy(){const root=document.getElementById('future-legacy');if(!root||root.dataset.ready)return;root.dataset.ready='true';(()=>{const room=root.querySelector('#'+'showroom'),stage=root.querySelector('#'+'stage');
let frame=0;
const motionOff=()=>root.classList.contains("no-motion");
room.addEventListener('pointermove',e=>{if(motionOff()||e.pointerType==='touch')return;cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>{const r=room.getBoundingClientRect();root.style.setProperty('--x',((e.clientX-r.left)/r.width-.5)*2);root.style.setProperty('--y',((e.clientY-r.top)/r.height-.5)*2);});});
room.addEventListener('pointerleave',()=>{cancelAnimationFrame(frame);root.style.setProperty('--x',0);root.style.setProperty('--y',0);});
const slides=JSON.parse(root.querySelector('[data-slides]').textContent);
let current=0,timer;
const selectors=[...root.querySelectorAll('[data-slide]')],img=root.querySelector('#'+'hero-product');
function selectSlide(index){current=index;clearTimeout(timer);const p=slides[current];selectors.forEach((b,i)=>{b.classList.toggle('selected',i===index);b.setAttribute('aria-pressed',String(i===index));});img.classList.add('changing');timer=setTimeout(()=>{img.src=p.img;img.alt=p.name+' IRONFATHER';stage.classList.toggle('cap',index===2);root.querySelector('#'+'hero-name').textContent=p.name;root.querySelector('#'+'hero-price').textContent=p.price;root.querySelector('#'+'hero-link').href=p.url;root.querySelector('#'+'product-category').textContent=p.category;img.classList.remove('changing');},motionOff()?0:160);}
selectors.forEach((b,i)=>{b.addEventListener('click',()=>selectSlide(i));b.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();const next=(i+(e.key==='ArrowRight'?1:-1)+3)%3;selectors[next].focus();selectSlide(next);}})});
let touchStart=null;room.addEventListener('touchstart',e=>{if(e.target.closest('a,button'))return;touchStart={x:e.touches[0].clientX,y:e.touches[0].clientY};},{passive:true});room.addEventListener('touchcancel',()=>{touchStart=null;},{passive:true});room.addEventListener('touchend',e=>{if(!touchStart)return;const dx=e.changedTouches[0].clientX-touchStart.x,dy=e.changedTouches[0].clientY-touchStart.y;if(Math.abs(dx)>65&&Math.abs(dx)>Math.abs(dy)*1.5)selectSlide((current+(dx<0?1:-1)+3)%3);touchStart=null;},{passive:true});
selectSlide(0);
slides.slice(1).forEach(p=>{const image=new Image();image.src=p.img;});
})();(()=>{
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  let saved = null;
  try { saved = localStorage.getItem('ironfather-motion'); } catch {}
  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'motion-toggle';
  root.querySelector('header')?.append(button);
  const surfaces = [...root.querySelectorAll('.product-image,.catalog-image,.product-gallery,.legacy-photo,.duo-image')];
  const layers = [...root.querySelectorAll('.legacy-photo,.duo-image')];
  surfaces.forEach(el => el.classList.add('depth-surface'));
  let enabled = false, frame = 0;
  const visible = new Set();
  const observer = new IntersectionObserver(entries => {
    entries.forEach(({target,isIntersecting}) => {
      target.classList.toggle('in-view',isIntersecting);
      if (isIntersecting) visible.add(target); else visible.delete(target);
    });
    schedule();
  }, {rootMargin:'40px'});
  [...layers, ...root.querySelectorAll('#showroom')].forEach(el => observer.observe(el));
  function render() {
    frame = 0;
    if (!enabled || document.hidden) return;
    visible.forEach(el => {
      const r = el.getBoundingClientRect();
      const progress = Math.max(-1,Math.min(1,(innerHeight/2-r.top-r.height/2)/(innerHeight/2+r.height/2)));
      el.style.setProperty('--travel',`${(progress*18).toFixed(2)}px`);
    });
  }
  function schedule() { if (!frame && enabled && !document.hidden) frame = requestAnimationFrame(render); }
  function update() {
    enabled = !reduced.matches && saved !== 'off';
    root.classList.toggle('no-motion',!enabled);
    button.textContent = enabled ? 'Mouvement · activé' : 'Mouvement · désactivé';
    button.setAttribute('aria-pressed',String(enabled));
    button.setAttribute('aria-label',reduced.matches ? 'Mouvement désactivé selon les préférences de votre appareil' : 'Activer les effets de mouvement');
    button.disabled = reduced.matches;
    if (!enabled) {
      cancelAnimationFrame(frame); frame = 0;
      for (const el of [root,...surfaces,...visible]) {
        ['--x','--y','--tilt-x','--tilt-y','--travel','--shine'].forEach(key=>el.style.removeProperty(key));
      }
    }
    schedule();
  }
  button.addEventListener('click',() => {
    saved = enabled ? 'off' : 'on';
    try { localStorage.setItem('ironfather-motion',saved); } catch {}
    update();
  });
  surfaces.forEach(el => {
    let pending = 0;
    el.addEventListener('pointermove',event => {
      if (!enabled || !fine.matches || event.pointerType === 'touch') return;
      cancelAnimationFrame(pending);
      pending = requestAnimationFrame(() => {
        if (!enabled) return;
        const r=el.getBoundingClientRect(),x=(event.clientX-r.left)/r.width,y=(event.clientY-r.top)/r.height;
        el.style.setProperty('--tilt-x',`${((.5-y)*5).toFixed(2)}deg`);
        el.style.setProperty('--tilt-y',`${((x-.5)*7).toFixed(2)}deg`);
        el.style.setProperty('--light-x',`${x*100}%`);
        el.style.setProperty('--light-y',`${y*100}%`);
        el.style.setProperty('--shine','1');
      });
    });
    el.addEventListener('pointerleave',() => {
      cancelAnimationFrame(pending);
      ['--tilt-x','--tilt-y','--shine'].forEach(key=>el.style.removeProperty(key));
    });
  });
  addEventListener('scroll',schedule,{passive:true});
  addEventListener('resize',schedule,{passive:true});
  document.addEventListener('visibilitychange',() => {
    root.classList.toggle('motion-suspended',document.hidden);
    schedule();
  });
  reduced.addEventListener('change',update);
  update();
})();}initFutureLegacy();document.addEventListener('shopify:section:load',initFutureLegacy);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
